import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=4f7a3a6f"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7a3a6f')) {
      api.createRecord('4f7a3a6f', component.options)
    } else {
      api.reload('4f7a3a6f', component.options)
    }
    module.hot.accept("./Sobre.vue?vue&type=template&id=4f7a3a6f", function () {
      api.rerender('4f7a3a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sobre/Sobre.vue"
export default component.exports